module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/advisor_tiktok_desktop_02@2x-290ec90f968c391a99031c5c4adaac45.jpg";